"use strict";
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var BaseUri = require("./Support/BaseUri");
var _q = require("./Support/Query");
var Request = require("./Support/Request");
function getSearchPage(opts) {
    var url = BaseUri.compose()
        .segment('search')
        .query(getSearchQuery(opts))
        .readable();
    return Request.getJson(url);
}
exports.getSearchPage = getSearchPage;
function getColorSearchPage(opts) {
    var url = BaseUri.compose('search', 'colors')
        .query(getSearchQuery(opts))
        .readable();
    return Request.getJson(url);
}
exports.getColorSearchPage = getColorSearchPage;
function getProjectSearchPage(opts) {
    var url = BaseUri.compose('projects', 'designs', 'search')
        .query(getSearchQuery(opts))
        .readable();
    return Request.getJson(url);
}
exports.getProjectSearchPage = getProjectSearchPage;
function getDesign(designCode) {
    var url = BaseUri.compose('designs', designCode)
        .toString();
    return Request.getJson(url);
}
exports.getDesign = getDesign;
function getDesignSpecs(designCode) {
    var url = BaseUri.compose('designs', designCode, 'specs')
        .toString();
    return Request.getJson(url);
}
exports.getDesignSpecs = getDesignSpecs;
function getInstalls(designCode) {
    var url = BaseUri.compose('designs', designCode, 'installs')
        .toString();
    return Request.getJson(url);
}
exports.getInstalls = getInstalls;
function getColorways(designCode) {
    var url = BaseUri.compose('designs', designCode, 'colorways')
        .toString();
    return Request.getJson(url);
}
exports.getColorways = getColorways;
function getColorway(designCode, colorCode) {
    var url = BaseUri.compose('designs', designCode, 'colorways', colorCode)
        .toString();
    return Request.getJson(url);
}
exports.getColorway = getColorway;
function getCustomColorway(_a) {
    var designCode = _a.designCode, yarns = _a.yarns, refLibs = _a.refLibs, refColor = _a.refColor, rgbs = _a.rgbs, clutColorwayId = _a.clutColorwayId;
    var url = BaseUri.compose('designs', designCode, 'colorways', 'custom')
        .query(__assign({}, _q.parseArg('yarns', yarns), _q.parseArg('refLibs', refLibs), _q.parseArg('refColor', refColor), _q.rgbsToArg(rgbs), _q.parseArg('clutColorwayId', clutColorwayId)));
    return Request.getJson(url.toString());
}
exports.getCustomColorway = getCustomColorway;
function createCustomClut(designCode, rgbs, colorwayName, refColor) {
    if (colorwayName === void 0) { colorwayName = ''; }
    if (refColor === void 0) { refColor = ''; }
    var url = BaseUri.compose()
        .segment('designs')
        .segment(designCode.toString())
        .segment('create')
        .segment('clutcolorway')
        .toString();
    return Request.postJson(url, {
        'rgbs': rgbs,
        'colorwayName': colorwayName,
        'colorCode': refColor
    });
}
exports.createCustomClut = createCustomClut;
function deleteCustomClut(clutColorwayId) {
    var url = BaseUri.compose()
        .segment('clutcolorways')
        .segment(clutColorwayId)
        .toString();
    return Request.deleteJson(url);
}
exports.deleteCustomClut = deleteCustomClut;
function getHaldClutColorwaysFromUser(userId) {
    var url = BaseUri.compose()
        .segment('users')
        .segment(userId.toString())
        .segment('clutcolorways')
        .toString();
    return Request.getJson(url);
}
exports.getHaldClutColorwaysFromUser = getHaldClutColorwaysFromUser;
function getPalette(designCode, rgbs, refColor) {
    if (refColor === void 0) { refColor = ''; }
    var url = BaseUri.compose('designs', designCode, 'palette')
        .query(__assign({}, _q.rgbsToArg(rgbs), { refColor: refColor }))
        .toString();
    return Request.getJson(url);
}
exports.getPalette = getPalette;
function getclutColorwayPalette(designCode, clutColorwayId, size) {
    if (size === void 0) { size = 5; }
    var url = BaseUri.compose('designs', designCode, 'clutColorways', clutColorwayId, 'palette')
        .query({ size: size })
        .toString();
    return Request.getJson(url);
}
exports.getclutColorwayPalette = getclutColorwayPalette;
function getAllPalettes(designCode, size, haldClutId) {
    if (size === void 0) { size = 5; }
    if (haldClutId === void 0) { haldClutId = ''; }
    var url = BaseUri.compose('designs', designCode, 'colorways', 'palettes')
        .query({ size: size })
        .query({ haldClutId: haldClutId })
        .toString();
    return Request.getJson(url);
}
exports.getAllPalettes = getAllPalettes;
function getRecentlyUsedDesigns() {
    var url = BaseUri.compose('getRecentlyUsedDesigns')
        .toString();
    return Request.getJson(url);
}
exports.getRecentlyUsedDesigns = getRecentlyUsedDesigns;
function saveRecentlyUsedDesign(designId) {
    var url = BaseUri.compose('recentlyUsedDesigns', 'save')
        .toString();
    return Request.postJsonOk(url, {
        'designId': designId,
    });
}
exports.saveRecentlyUsedDesign = saveRecentlyUsedDesign;
function getSearchQuery(_a) {
    var page = _a.page, pageSize = _a.pageSize, orderBy = _a.orderBy, categoryIds = _a.categoryIds, brandIds = _a.brandIds, collectionIds = _a.collectionIds, engineIds = _a.engineIds, repeatHeight = _a.repeatHeight, repeatWidth = _a.repeatWidth, installIds = _a.installIds, query = _a.query, sectionId = _a.sectionId, recolorable = _a.recolorable, collectionTypeIds = _a.collectionTypeIds;
    return __assign({ '$inlinecount': 'allpages', '$top': pageSize, '$skip': pageSize * page, '$orderby': orderBy ? orderBy.join(',') : 'DesignName,ColorName' }, _q.parseArg('q', query), _q.parseArg('b', brandIds), _q.parseArg('c', categoryIds), _q.parseArg('col', collectionIds), _q.parseArg('e', engineIds), _q.parseArg('i', installIds), _q.parseArg('w', repeatWidth), _q.parseArg('h', repeatHeight), _q.parseArg('r', recolorable), _q.parseArg('s', sectionId), _q.parseArg('coltype', collectionTypeIds));
}
